import {
  AlarmStatus,
  FilterConfig,
  StatusFilterOption,
  TimePeriod,
} from '@hakimo-ui/hakimo/types';

const statusOptions: StatusFilterOption<AlarmStatus>[] = [
  { id: 'analyzing', name: 'Analyzing' },
  { id: 'pending', name: 'Pending' },
  { id: 'resolvedByHakimo', name: 'Resolved by Hakimo' },
  { id: 'resolvedManually', name: 'Resolved Manually' },
  { id: 'acsAck', name: 'Alarm Acknowledged via ACS' },
  { id: 'inProgress', name: 'In Progress' },
];

export const PAGE_SIZE = 50;
export const ALARM_QUERY_INTERVAL = 5000;

export const ANALYZING_DEFAULT_STATUS_TENANTS = ['elevance-prod'];

export const filterConfigs: FilterConfig[] = [
  {
    type: 'status',
    defaultValue: {
      values: [],
      negative: false,
    },
    options: statusOptions,
  },
  {
    type: 'time',
    defaultValue: {
      period: TimePeriod.PAST_12_HOURS,
      customRangeStart: 0,
      customRangeEnd: 0,
    },
  },
  {
    type: 'agedAlarm',
    defaultValue: { id: TimePeriod.ALL_TIME, name: TimePeriod.ALL_TIME },
  },
  {
    type: 'sourceSystem',
    defaultValue: [],
  },
  {
    type: 'location',
    defaultValue: {
      values: [],
      negative: false,
    },
  },
  {
    type: 'type',
    defaultValue: {
      values: [],
      negative: false,
    },
  },
  {
    type: 'sourceEntity',
    defaultValue: {
      values: [],
      negative: false,
    },
  },
  {
    type: 'employee',
    defaultValue: {
      values: [],
      negative: false,
    },
  },
  {
    type: 'tenant',
    defaultValue: {
      values: [],
      negative: false,
    },
  },
  {
    type: 'mannedLocation',
    defaultValue: undefined,
  },
  {
    type: 'tap',
    defaultValue: undefined,
  },
];
